// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8npaI","index":"styles_index__2jl6A"};